import { useQuery } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useGetRecognitionSpendingSummary = ({ recognitionCode } = {}, options) => {
  return useQuery(
    ['recognitionSpendingSummary', recognitionCode],
    () => recognitionServices.spendingSummary(recognitionCode),
    {
      ...options,
      enabled: !!recognitionCode,
      staleTime: Infinity,
      retry: false
    }
  );
};
